"use client";

import { useState, Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

import { SearchOutlinedIcon } from "./styles";
import LoadingPage from "components/LoadingPage";
import ProductCard4 from "components/product-cards/product-card-4";
import ProductCardCarrousel from "@/components/product-cards/product-card-carrousel";

export default function SearchInput() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    if (!search.trim()) return;
    setLoading(true);
    try {
      const res = await fetch(`/api/search?q=${encodeURIComponent(search)}`);
      const data = await res.json();
      setProducts(data.products || []);
    } catch (err) {
      console.error("Error searching:", err);
    } finally {
      setLoading(false);
    }
  };

  const INPUT_PROPS = {
    sx: {
      border: 0,
      height: 44,
      paddingRight: 0,
      overflow: "hidden",
      backgroundColor: "grey.200",
      "& .MuiOutlinedInput-notchedOutline": {
        border: 0
      }
    },
    endAdornment: (
      <Button
        color="primary"
        disableElevation
        variant="contained"
        onClick={fetchData}
        sx={{
          px: "3rem",
          height: "100%",
          borderRadius: "0 4px 4px 0"
        }}
      >
        Buscar
      </Button>
    ),
    startAdornment: <SearchOutlinedIcon fontSize="small" />
  };

  return (
    <Suspense>
      <TextField
        fullWidth
        sx={{
          "& .MuiInputBase-input": {
            fontSize: "16px",
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
          },
        }} variant="outlined"
        onChange={(e) => setSearch(e.target.value)}
        InputProps={INPUT_PROPS}
      />

      <Box position="relative" flex="1 1 0" maxWidth="670px" mx="auto" mt={3}>
        {loading && <LoadingPage />}

        {!loading && products.length > 0 && (
          <Grid container spacing={2} mt={4}>
            {products.map((x) => (
              <Grid key={x.id} lg={3} sm={6} xs={6}>
                <ProductCardCarrousel product={x} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
    </Suspense>
  );
}
